import Scanner from "@pages/Scanner/Scanner";

export default Scanner;
